import type { ApplyForGovFunds } from '@generated/graphql';

export type UnsavedAccountFields = {
  applyForGovFunds?: ApplyForGovFunds[];
  eligibleForDisabilityTaxCredit?: boolean;
  respAllBeneficiariesAreInBc?: boolean;
};

export const resolveUnsavedAccountFields = ({
  server,
  local,
  alreadyHydrated,
}: {
  server: UnsavedAccountFields;
  local: UnsavedAccountFields;
  alreadyHydrated: boolean;
}): UnsavedAccountFields => {
  if (!alreadyHydrated) {
    return {
      applyForGovFunds: server.applyForGovFunds,
      eligibleForDisabilityTaxCredit: server.eligibleForDisabilityTaxCredit,
      respAllBeneficiariesAreInBc: server.respAllBeneficiariesAreInBc,
    };
  }

  return {
    applyForGovFunds: local.applyForGovFunds ?? server.applyForGovFunds,
    eligibleForDisabilityTaxCredit:
      local.eligibleForDisabilityTaxCredit ??
      server.eligibleForDisabilityTaxCredit,
    respAllBeneficiariesAreInBc:
      local.respAllBeneficiariesAreInBc ?? server.respAllBeneficiariesAreInBc,
  };
};
